/**
 * @param {string} value
 * @returns {number[]}
 */
const toDigits = (value) => [ ...value ].map(Number);

/**
 * @param {string} number
 * @param {HcpId.WeightedModParams} params
 * @returns {boolean}
 */
function weightedMod(number, { weights, modulus, checkDigitIndex }) {
    const digits = toDigits(number);
    const checkDigit = digits[checkDigitIndex];
    const payload = digits.filter((digit, index) => index !== checkDigitIndex);
    if (payload.length !== weights.length) {
        return false;
    }

    const sum = payload.reduce((total, digit, index) => total + digit * weights[index], 0);
    return sum % modulus === checkDigit;
}

/**
 * @param {string} number
 * @param {HcpId.LuhnParams} params
 * @returns {boolean}
 */
function luhn(number, { prefix = '' } = {}) {
    const digits = toDigits(`${prefix}${number}`).reverse();
    const sum = digits.reduce((total, digit, index) => {
        if (index % 2 === 0) {
            return total + digit;
        }
        const doubled = digit * 2;
        return total + (doubled > 9 ? doubled - 9 : doubled);
    }, 0);
    return sum % 10 === 0;
}

/** @type {Record<string, (number: string, params: any) => boolean>} */
export const algorithms = { weightedMod, luhn };
